module.exports = __webpack_public_path__ + "static/media/ProjectAssetsIcon.527cdeb9.svg";